import React from 'react';

import {
    AspectRatioCard,
    AspectRatioCardImage,
} from '@homeaway/react-aspect-ratio-card';

import {handleClick, ACTION_LOCATION} from './../events';
import {ASPECT_RATIO, BASE_CLASS, buildImageUrl} from './../constants';

import LazyLoad from './../../../components/common/lazy-load/LazyLoad';
import ImagePlaceholder from './../../../components/common/carousel/Placeholder';
import EdapViewTracker from './../../../components/common/edap-view-tracker/EdapViewTracker';
import CommonCarousel from './../../../components/common/carousel/Carousel';

const asRefinementCard = (lbsId) => {
    const clickLink = (card, index) =>
        handleClick({
            lbsId,
            position: index + 1,
            filterId: card.filterId,
        });

    return (card, index) => (
        <AspectRatioCard
            key={card.filterId}
            aspectRatio={ASPECT_RATIO}
            hasHover
        >
            <div key={'figure'} data-slot={'figure'}>
                <a
                    href={card.serpUrl}
                    title={card.heading}
                    onClick={clickLink(card, index)}
                >
                    <LazyLoad placholder={<ImagePlaceholder />}>
                        <AspectRatioCardImage
                            imageUri={buildImageUrl(card.imageUrl)}
                            aspectRatio={ASPECT_RATIO}
                        />
                    </LazyLoad>
                </a>
            </div>
            <div key={'content'} data-slot={'content'}>
                <a href={card.serpUrl} onClick={clickLink(card, index)}>
                    <h4 className={`${BASE_CLASS}__card-heading`}>
                        {card.heading}
                    </h4>
                </a>
            </div>
        </AspectRatioCard>
    );
};

const DynamicDestinationRefinementsDesktop = ({
    lbsId,
    heading,
    subheading,
    cards,
}) => {
    const refinementCards = cards.map(asRefinementCard(lbsId));

    return (
        <div className={`${BASE_CLASS} container module module--no-padding`}>
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'top',
                }}
                edapEvent={'content_module.presented'}
            />
            <CommonCarousel
                aspectRatio={ASPECT_RATIO}
                titleMessage={heading}
                subtitleMessage={subheading}
            >
                {refinementCards}
            </CommonCarousel>
            <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}} />
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'bottom',
                }}
                edapEvent={'content_module.presented'}
            />
        </div>
    );
};

DynamicDestinationRefinementsDesktop.displayName =
    'DynamicDestinationRefinementsDesktop';

export default DynamicDestinationRefinementsDesktop;
